import gql from 'graphql-tag'

export const emailAvailabilityQuery = gql`
query emailAvailability($email: String!) {
    emailAvailability(email: $email)
}
`
